import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';
import { computed, Injectable } from '@angular/core';
import { WorkGridItemObject } from '@it2go/types';

@Injectable()
export class FolderMedicationsWorksStore extends ComponentStoreV2Factory {

    public works = computed<WorkGridItemObject[] | null>(
        () => this.data.getFolderMedications()?.items?.[0]?.works || null,
    );

}
